import React, { useState, useEffect, useCallback, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import { notification, Empty, Switch } from 'antd';
import { formValueSelector } from 'redux-form';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Row, Col } from 'antd';
import {
  getMerchantWallets,
  getMoreMerchantWallets,
  deleteMerchantWallet,
  resetPageCounter,
  setWalletAsMain,
  resetTwoFaState,
  getWalletPrivateKey,
  getWalletMnemonicPhrase,
  getPassphrase,
} from '../../redux/actions/merchantWallets';
import ReactPaginate from 'react-paginate';
import { getMerchantBalances, getMerchantData } from '../../redux/actions/merchantData';
import WalletsFilters from './WalletsFilters';
import WalletsPagination from './WalletsPagination';
import ReplenishModal from '../ReplenishModal/ReplenishModal';
import PrivateKeyModal from './PrivateKeyModal';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './WalletsList.scss';
import { getUserMerchants } from '../../redux/actions/adminPanel/adminUsers';
import {
  checkAutosignStatus,
  getWithdrawWallets,
  setPasswordSignature,
  downloadAutosign,
  checkPasswordStatus,
  downloadNewAutosignError,
} from '../../redux/actions/withdraw';
import WalletsNewList from './WalletsNewList';
import WalletItem from './WalletItem';
import WalletDeleteModal from './MerchantWalletsActions/WalletDeleteModal';
import WalletSettingsModal from './MerchantWalletsActions/WalletSettingsModal';
import SignPasswordModal from '../SignPasswordModal/SignPasswordModal';
import PasswordModal from './PasswordModal';
import useWindowSize from '../../utils/resizeHook';
import { adminApi } from '../../service/admin-api';
import { identity } from '../../utils/getIdentity';

const WalletsList = ({
  formName,
  merchantId,
  networkFilter,
  wallets,
  typeWallet,
  currencies,
  userId,
  getMerchantWallets,
  getMoreMerchantWallets,
  page,
  pages,
  countItem,
  autosignStatus,
  resetPageCounter,
  walletsFilters,
  fetching,
  getMerchantData,
  merchantData,
  deleteMerchantWallet,
  setWalletAsMain,
  resetTwoFaState,
  getWalletPrivateKey,
  getWalletMnemonicPhrase,
  getPassphrase,
  setPasswordSignature,
  downloadAutosign,
  passwordStatus,
  checkAutosignStatus,
  checkPasswordStatus,
  autosignStep,
  downloadAutosignStep,
  downloadError,
  type = 'user',
  userMerchants,
  isApprovedToken,
}) => {
  const [socket, setSocket] = useState(undefined);
  const [walletId, setWalletId] = useState('');
  const [walletAddress, setWalletAddress] = useState('');
  const [walletCurrency, setWalletCurrency] = useState('');
  const [isReplenishModalOpen, setIsReplenishModalOpen] = useState(false);
  const [isKeyModalOpen, setIsKeyModalOpen] = useState(false);
  const [isFetched, setIsFetched] = useState(false);
  const [adminPage, setAdminPage] = useState(1);
  const [adminPages, setAdminPages] = useState(1);
  const [hideZeroCheckbox, setHideZeroCheckbox] = useState(
    JSON.parse(localStorage.getItem('cpayHideZeroBalancesMerchant')) || false
  );
  const [walletsAdmin, setWalletsAdmin] = useState([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [showWalletBy, setShowWalletBy] = useState(null);
  const [isSegwit, setIsSegwit] = useState(false);
  const [name, setName] = useState('');
  const [securityRefreshedWalletId, setSecurityRefreshedWalletId] = useState(null);
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [isOpenSignPassword, setIsOpenSignPassword] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openSettingsModal, setOpenSettingsModal] = useState(false);
  const [isOpenDownload, setIsOpenDownload] = useState(false);
  const [modalTitle, setModalTitle] = useState(false);
  const [password, setPassword] = useState('');
  const selectedWalletRef = useRef(null);
  selectedWalletRef.current = selectedWallet;
  const { currentWidth } = useWindowSize();
  const location = window.location.href;
  const dispatch = useDispatch();

  const isAdmin = location?.includes('admin/');

  const { pathname } = useLocation();
  const isFromMerchantsWallets = pathname.includes('/merchants/wallets') || pathname === '/wallets';
  const isMerchantWalletRoute = pathname.includes('/merchants/wallets');
  const [walletVersionTick, setWalletVersionTick] = useState(0);
  const [adminWalletVersion, setAdminWalletVersion] = useState(undefined);
  const walletVersionStorageKey = merchantId
    ? `adminMerchantWalletVersion:${merchantId}`
    : 'adminMerchantWalletVersion';
  const effectiveWalletVersion =
    type === 'admin'
      ? adminWalletVersion || (merchantData?._id === merchantId ? merchantData?.settingWallet?.version : undefined)
      : localStorage.getItem('walletVersion');

  const canSwitchWalletVersion =
    type === 'admin' &&
    merchantData?.settingWallet?.version === 'v2' &&
    merchantData?.settingWallet?.defaultSetup === 'v1';

  const withMerchantWalletVersion = params => {
    if (effectiveWalletVersion) {
      console.log('Setting walletVersion via withMerchantWalletVersion helper, walletVersion:', effectiveWalletVersion);
    }
    return {
      ...params,
      ...(isMerchantWalletRoute && effectiveWalletVersion ? { walletVersion: effectiveWalletVersion } : {}),
    };
  };

  useEffect(() => {
    const bump = () => setWalletVersionTick(n => n + 1);
    const onStorage = e => {
      if (e.key === 'walletVersion') bump();
    };
    window.addEventListener('walletVersionChange', bump);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('walletVersionChange', bump);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  const defaultFilterValues = {
    order: 'DESC',
    search: '',
    limit: 10,
    currencyIds: currencies.filter(currency => currency.currencyType === 'currency').map(currency => currency._id),
    typeNetwork: networkFilter,
  };

  const getAdminMerchantWallet = async body => {
    setLoading(true);

    try {
      const response = await adminApi.getAdminMerchantWallet(userId, merchantId, body);
      if (response?.data) {
        setAdminPage(response?.data?.page);
        setAdminPages(response?.data?.pages);
        setWalletsAdmin(response?.data?.entities);
      } else {
        setWalletsAdmin([]);
      }
    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (type === 'admin' && merchantId) {
      const storedVersion = localStorage.getItem(walletVersionStorageKey);
      setAdminWalletVersion(storedVersion || undefined);
    }
  }, [type, merchantId]);

  useEffect(() => {
    if (type === 'admin' && merchantId && adminWalletVersion) {
      localStorage.setItem(walletVersionStorageKey, adminWalletVersion);
    }
  }, [type, merchantId, adminWalletVersion]);

  useEffect(() => {
    if (isAdmin) {
      dispatch(getUserMerchants(userId));
    }
  }, [userId]);

  useEffect(() => {
    if (userMerchants?.length > 0 && merchantId && isAdmin) {
      const name = userMerchants?.filter(item => item?._id === merchantId);
      setName(name[0]?.name);
    } else {
      setName('');
    }
  }, [userMerchants, merchantId]);

  useEffect(() => {
    if (merchantId) {
      getMerchantData(merchantId, isAdmin ? userId : undefined);
    } else if (defaultFilterValues?.currencyIds?.length > 1 && isAdmin) {
      const { currencyIds } = defaultFilterValues;
      console.log(
        'Setting walletVersion in getAdminMerchantWallet payload (useEffect 1), walletVersion:',
        effectiveWalletVersion
      );
      getAdminMerchantWallet({
        ...defaultFilterValues,
        order: walletsFilters?.order || 'DESC',
        currencyIds: currencyIds.join(',') || undefined,
        typeWallet: typeWallet,
        showTokens: true,
        positiveBalance: hideZeroCheckbox,
        ...(effectiveWalletVersion ? { walletVersion: effectiveWalletVersion } : {}),
      });
    } else if (defaultFilterValues?.currencyIds?.length === 0 && isAdmin) {
      setWalletsAdmin([]);
    }
  }, [merchantId, networkFilter, hideZeroCheckbox, walletVersionTick, effectiveWalletVersion, adminWalletVersion]);

  useEffect(() => {
    console.log(
      '[useEffect 2] conditions check:',
      'currencyIdsLength:', defaultFilterValues?.currencyIds?.length,
      'isAdmin:', isAdmin,
      'merchantData?._id:', merchantData?._id,
      'merchantId:', merchantId,
      'merchantData?._id === merchantId:', merchantData?._id === merchantId,
      'walletsFilters?.order:', walletsFilters?.order,
      'effectiveWalletVersion:', effectiveWalletVersion,
    );
    if (defaultFilterValues?.currencyIds?.length > 1 && isAdmin && merchantData?._id === merchantId) {
      const { currencyIds } = defaultFilterValues;
      console.log(
        '[useEffect 2] ENTERED branch — Setting walletVersion in getAdminMerchantWallet payload (useEffect 2), walletVersion:',
        effectiveWalletVersion
      );
      getAdminMerchantWallet({
        ...defaultFilterValues,
        order: walletsFilters?.order || 'DESC',
        currencyIds: currencyIds.join(',') || undefined,
        typeWallet: typeWallet,
        showTokens: true,
        positiveBalance: hideZeroCheckbox,
        ...(effectiveWalletVersion ? { walletVersion: effectiveWalletVersion } : {}),
      });
    } else if (defaultFilterValues?.currencyIds?.length === 0) {
      console.log('[useEffect 2] ENTERED else-if branch — setting walletsAdmin to empty');
      setWalletsAdmin([]);
    } else {
      console.log('[useEffect 2] SKIPPED — no branch matched');
    }
  }, [walletsFilters?.order, effectiveWalletVersion, merchantData]);

  useEffect(() => {
    if (
      Object.keys(walletsFilters).length !== 0 &&
      walletsFilters.constructor === Object &&
      merchantId &&
      merchantId.length &&
      type !== 'admin'
    ) {
      if (walletsFilters.limit || walletsFilters.order) {
        submitFilters();
      }
    }
  }, [
    walletsFilters.limit,
    walletsFilters.order,
    networkFilter,
    hideZeroCheckbox,
    walletVersionTick,
    effectiveWalletVersion,
  ]);

  const handleReplenishButton = (address, currency, isModalOpen) => {
    setWalletAddress(address);
    setWalletCurrency(currency);
    setIsReplenishModalOpen(isModalOpen);
  };

  const openNotification = () => {
    notification.success({
      message: t('copied'),
      duration: 2,
    });
  };

  const openModal = walletId => {
    setWalletId(walletId);
    setIsKeyModalOpen(true);
  };

  const closeModal = () => {
    setIsKeyModalOpen(false);
    resetTwoFaState(false);
  };

  const consumeSecurityRefresh = useCallback(() => {
    setSecurityRefreshedWalletId(null);
  }, []);

  const handleOpenSettings = wallet => {
    setSelectedWallet(wallet);
    setOpenSettingsModal(true);
    checkAutosignStatus(merchantId, wallet?._id);
    checkPasswordStatus(merchantId, wallet?._id);
  };

  const handleOpenDelete = wallet => {
    setSelectedWallet(wallet);
    setOpenDeleteModal(true);
  };

  const handleOpenSignPassword = wallet => {
    setSelectedWallet(wallet);
    checkAutosignStatus(merchantId, wallet?._id);
    checkPasswordStatus(merchantId, wallet?._id);
    setIsOpenSignPassword(true);
  };

  const closeSign = () => {
    setIsOpenSignPassword(false);
    dispatch(downloadNewAutosignError(false));
    setModalTitle(false);
    const w = selectedWalletRef.current;
    if (merchantId && w?._id) {
      checkPasswordStatus(merchantId, w._id);
      setSecurityRefreshedWalletId(w._id);
    }
  };

  const closeSettingsOnly = () => {
    setOpenSettingsModal(false);
  };

  const openDownload = () => {
    setOpenSettingsModal(false);
    setIsOpenDownload(true);
  };

  const checkDownloadAutosign = useCallback(() => {
    const w = selectedWalletRef.current;
    if (merchantId && w?._id) {
      checkAutosignStatus(merchantId, w._id);
      checkPasswordStatus(merchantId, w._id);
    }
  }, [merchantId, checkAutosignStatus, checkPasswordStatus]);

  const loadMoreWallets = page => {
    const { order, limit, search, currencyIds } = walletsFilters;
    getMoreMerchantWallets(
      merchantId,
      withMerchantWalletVersion({
        order: order,
        limit: limit,
        search: search.trim(),
        currencyIds: currencyIds.join(',') || undefined,
        typeWallet: typeWallet,
        page: page,
        typeNetwork: networkFilter,
        showTokens: false,
        positiveBalance: hideZeroCheckbox,
      })
    );
  };

  const loadMoreAdminWallets = selectedPage => {
    const { order, limit, search, currencyIds } = walletsFilters;
    const pageNumber = selectedPage.selected + 1;
    console.log(
      'Setting walletVersion in getAdminMerchantWallet payload (loadMoreAdminWallets), walletVersion:',
      effectiveWalletVersion
    );
    getAdminMerchantWallet({
      order: order,
      limit: limit,
      search: search.trim(),
      currencyIds: currencyIds.join(',') || undefined,
      typeWallet: typeWallet,
      page: pageNumber,
      typeNetwork: networkFilter,
      showTokens: true,
      positiveBalance: hideZeroCheckbox,
      ...(effectiveWalletVersion ? { walletVersion: effectiveWalletVersion } : {}),
    }).then(response => {
      if (response?.data) {
        setWalletAddress(response?.data?.entities);
      }
    });
  };

  const updateAfterChangeSegwit = () => {
    const { order, limit, search, currencyIds } = walletsFilters;
    getMerchantWallets(
      merchantId,
      withMerchantWalletVersion({
        order: order,
        limit: limit,
        search: search.trim(),
        currencyIds: currencyIds.join(',') || undefined,
        typeWallet: typeWallet,
        page: page,
        typeNetwork: networkFilter,
        showTokens: false,
        positiveBalance: hideZeroCheckbox,
      })
    ).then(() => setIsFetched(true));
  };

  useEffect(() => {
    if (isSegwit) {
      updateAfterChangeSegwit();
    }

    setIsSegwit(false);
  }, [isSegwit]);

  useEffect(() => {
    if (isApprovedToken) {
      const { order, limit, search, currencyIds } = walletsFilters;
      getMerchantWallets(
        merchantId,
        withMerchantWalletVersion({
          order: order,
          limit: limit,
          search: search.trim(),
          currencyIds: currencyIds.join(',') || undefined,
          typeWallet: typeWallet,
          page: 1,
          typeNetwork: networkFilter,
          showTokens: false,
          positiveBalance: hideZeroCheckbox,
        })
      ).then(() => setIsFetched(true));
    }
  }, [isApprovedToken]);

  const submitFilters = () => {
    const { order, limit, search, currencyIds } = walletsFilters;
    resetPageCounter();
    if (type !== 'admin') {
      getMerchantWallets(
        merchantId,
        withMerchantWalletVersion({
          order: order,
          limit: limit,
          search: search.trim(),
          currencyIds: currencyIds.join(',') || undefined,
          typeWallet: typeWallet,
          page: 1,
          typeNetwork: networkFilter,
          showTokens: false,
          positiveBalance: hideZeroCheckbox,
        })
      ).then(() => setIsFetched(true));
    } else if (isAdmin) {
      console.log(
        'Setting walletVersion in getAdminMerchantWallet payload (submitFilters admin), walletVersion:',
        effectiveWalletVersion
      );
      getAdminMerchantWallet({
        order: order,
        limit: limit,
        search: search.trim(),
        currencyIds: currencyIds.join(',') || undefined,
        typeWallet: typeWallet,
        page: 1,
        typeNetwork: networkFilter,
        showTokens: true,
        positiveBalance: hideZeroCheckbox,
        ...(effectiveWalletVersion ? { walletVersion: effectiveWalletVersion } : {}),
      }).then(response => {
        if (response?.data) {
          setWalletAddress(response?.data?.entities);
        }
      });
    }
  };

  const updateList = () => {
    submitFilters();
  };

  const resetFilters = () => {
    const { currencyIds } = defaultFilterValues;
    if (type !== 'admin') {
      getMerchantWallets(
        merchantId,
        withMerchantWalletVersion({
          ...defaultFilterValues,
          currencyIds: currencyIds.join(',') || undefined,
          typeWallet: typeWallet,
          page: 1,
          typeNetwork: networkFilter,
          showTokens: false,
          positiveBalance: hideZeroCheckbox,
        })
      ).then(() => setIsFetched(true));
    } else if (isAdmin) {
      console.log(
        'Setting walletVersion in getAdminMerchantWallet payload (resetFilters admin), walletVersion:',
        effectiveWalletVersion
      );
      getAdminMerchantWallet({
        ...defaultFilterValues,
        currencyIds: currencyIds.join(',') || undefined,
        typeWallet: typeWallet,
        page: 1,
        typeNetwork: networkFilter,
        showTokens: true,
        positiveBalance: hideZeroCheckbox,
        ...(effectiveWalletVersion ? { walletVersion: effectiveWalletVersion } : {}),
      }).then(response => {
        if (response?.data) {
          setWalletsAdmin(response?.data?.entities);
        }
      });
    }
  };

  useEffect(() => {
    if (type !== 'admin') {
      socket && socket.disconnect();
      setSocket(undefined);
      createSocket(merchantId);
    }
  }, [merchantId]);

  const createSocket = merchantId => {
    const io = window.io;
    const socket = io(process.env.REACT_APP_API_URL, {
      allowEIO3: true,
      withCredentials: true,
    });
    socket.on('connect', () => {
      socket.emit('sign-in-merchant', { token: localStorage.getItem('authToken'), merchantId });
      setSocket(socket);
    });
    socket.on('updatedBalance', () => {
      // const { currencyIds } = defaultFilterValues;
      if (merchantId) {
        //  getMerchantWallets(merchantId, {
        //   ...defaultFilterValues,
        //   currencyIds: currencyIds.join(',') || undefined,
        //   typeWallet: typeWallet,
        //   page: 1,
        //   typeNetwork: networkFilter,
        //   showTokens: false,
        // }, true).then(() => setIsFetched(true));
        // getMerchantBalances(merchantId, networkFilter, true, false, walletVersion)
        // getWithdrawWallets(merchantId, currencyIds.join(',') || undefined, networkFilter, true, true);
      }
    });
    socket.on('disconnect', () => {});
  };

  const rawWallets = type !== 'admin' ? wallets : walletsAdmin;
  const isV2 = effectiveWalletVersion === 'v2' && type !== 'admin';
  const walletsToUse = !isV2
    ? rawWallets?.map(wallet => {
        if (wallet.balances) {
          const nativeIndex = wallet.balances.findIndex(b => b.currency.currencyType === 'currency');
          const primaryIndex = nativeIndex >= 0 ? nativeIndex : 0;
          const primary = wallet.balances[primaryIndex];
          const tokens = wallet.balances
            .filter((_, i) => i !== primaryIndex)
            .map(b => ({
              currency: b.currency.name,
              currencyId: b.currency.id,
              currencyType: b.currency.currencyType,
              nodeType: b.currency.nodeType,
              holdBalance: b.holdBalance,
              balance: { value: b.balance.value, usd: b.balance.usd },
            }));
          return {
            _id: wallet._id,
            address: wallet.address,
            currency: primary.currency.name,
            currencyId: primary.currency.id,
            currencyType: primary.currency.currencyType,
            nodeType: primary.currency.nodeType,
            balance: { value: primary.balance.value, usd: primary.balance.usd },
            typeWallet: wallet.typeWallet,
            main: wallet.main,
            tokens,
            createdAt: wallet.createdAt,
            isSegwit: wallet.isSegwit,
          };
        }
        return wallet;
      })
    : null;
  const canShowWallets = type !== 'admin' ? isFetched : !loading;

  return (
    <React.Fragment>
      <ReplenishModal
        walletAddress={walletAddress}
        walletCurrency={walletCurrency}
        isReplenishModalOpen={isReplenishModalOpen}
        handleReplenishButton={handleReplenishButton}
      />
      <PrivateKeyModal
        merchantId={merchantId}
        walletId={walletId}
        setWalletId={setWalletId}
        isKeyModalOpen={isKeyModalOpen}
        closeModal={closeModal}
        openNotification={openNotification}
        getWalletPrivateKey={getWalletPrivateKey}
        showWalletBy={showWalletBy}
        getWalletMnemonicPhrase={getWalletMnemonicPhrase}
        getPassphrase={getPassphrase}
      />
      <WalletDeleteModal
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        merchantId={merchantId}
        walletId={selectedWallet?._id}
        walletAddress={selectedWallet?.address}
        deleteMerchantWallet={deleteMerchantWallet}
        typeWallet={typeWallet}
        page={page}
        pages={pages}
        countItem={countItem}
        walletsFilters={walletsFilters}
        networkFilter={networkFilter}
        isFromMerchantsWallets={isFromMerchantsWallets}
      />
      <SignPasswordModal
        merchantId={merchantId}
        autosignStatus={autosignStatus}
        passwordStatus={passwordStatus}
        isOpen={isOpenSignPassword}
        walletId={selectedWallet?._id}
        downloadAutosign={downloadAutosign}
        setPasswordSignature={setPasswordSignature}
        onCancel={closeSign}
        modalTitle={modalTitle}
        autosignStep={autosignStep}
        downloadAutosignStep={downloadAutosignStep}
        password={password}
      />
      <WalletSettingsModal
        openSettingsModal={openSettingsModal}
        setOpenSettingsModal={setOpenSettingsModal}
        selectedWallet={selectedWallet}
        wallet={selectedWallet}
        merchantId={merchantId}
        setSelectedWallet={setSelectedWallet}
        getWalletPrivateKey={getWalletPrivateKey}
        getWalletMnemonicPhrase={getWalletMnemonicPhrase}
        getPassphrase={getPassphrase}
        openNotification={openNotification}
        resetTwoFaState={resetTwoFaState}
        setWalletAsMain={setWalletAsMain}
        closeModal={closeSettingsOnly}
        statusAutosign={autosignStatus}
        statusPassword={passwordStatus}
        openSign={() => setIsOpenSignPassword(true)}
        typeWallet={typeWallet}
        downloadAutosign={downloadAutosign}
        checkStatusPassword={() => {
          const w = selectedWalletRef.current;
          if (merchantId && w?._id) {
            checkPasswordStatus(merchantId, w._id);
          }
        }}
        page={page}
        walletsFilters={walletsFilters}
        networkFilter={networkFilter}
        openDownload={openDownload}
        updateList={() => {
          checkDownloadAutosign();
          submitFilters();
          const w = selectedWalletRef.current;
          if (w?._id) {
            setSecurityRefreshedWalletId(w._id);
          }
        }}
        downloadError={downloadError}
        setIsSegwit={() => setIsSegwit(true)}
      />
      <PasswordModal
        isOpen={isOpenDownload}
        closeModal={() => setIsOpenDownload(false)}
        downloadAutosignStep={downloadAutosignStep}
        merchantId={merchantId}
        walletId={selectedWallet?._id}
        downloadAutosign={downloadAutosign}
      />
      {currencies && currencies.length && (
        <>
          {canSwitchWalletVersion && (
            <div
              style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12, gap: 8, alignItems: 'center' }}
            >
              <span>Use Wallets 2.0 by default</span>
              <Switch
                checked={effectiveWalletVersion !== 'v1'}
                onChange={value => setAdminWalletVersion(value ? 'v2' : 'v1')}
              />
            </div>
          )}
          <WalletsFilters
            formName={formName}
            merchantName={!isAdmin ? merchantData.name : name}
            currencies={currencies}
            initialValues={defaultFilterValues}
            submitFilters={submitFilters}
            resetFilters={resetFilters}
            fetching={fetching}
            hideZeroCheckbox={hideZeroCheckbox}
            setCheckbox={setHideZeroCheckbox}
          />
        </>
      )}
      {canShowWallets && isV2 && rawWallets && rawWallets?.length > 0 ? (
        <div className={`wallets-page ${fetching ? 'wallets-page_fetching' : ''}`}>
          <WalletsNewList
            wallets={rawWallets}
            page={type === 'admin' ? adminPage : page}
            pages={type === 'admin' ? adminPages : pages}
            fetching={fetching || loading}
            merchantId={merchantId}
            networkFilter={networkFilter}
            currencyIds={defaultFilterValues.currencyIds}
            getMerchantWallets={getMerchantWallets}
            getMoreMerchantWallets={getMoreMerchantWallets}
            search={walletsFilters?.search || ''}
            hideZeroCheckbox={hideZeroCheckbox}
            walletVersion={effectiveWalletVersion}
            openSettings={handleOpenSettings}
            openDelete={handleOpenDelete}
            openSignPassword={handleOpenSignPassword}
            securityRefreshedWalletId={securityRefreshedWalletId}
            onSecurityRefreshConsumed={consumeSecurityRefresh}
          />
        </div>
      ) : canShowWallets && !isV2 && walletsToUse && walletsToUse?.length > 0 ? (
        <>
          <div className={`wallets-page ${fetching ? 'wallets-page_fetching' : ''}`}>
            {walletsToUse.map((wallet, index) => (
              <WalletItem
                autosignStep={autosignStep}
                downloadAutosignStep={downloadAutosignStep}
                key={wallet._id}
                merchantId={merchantId}
                wallet={wallet}
                type={type}
                typeWallet={typeWallet}
                page={page}
                pages={pages}
                countItem={countItem}
                downloadAutosign={downloadAutosign}
                walletsFilters={walletsFilters}
                openModal={openModal}
                setPasswordSignature={setPasswordSignature}
                autosignStatus={autosignStatus}
                openNotification={openNotification}
                deleteMerchantWallet={deleteMerchantWallet}
                handleReplenishButton={handleReplenishButton}
                setWalletAsMain={setWalletAsMain}
                checkAutosignStatus={checkAutosignStatus}
                checkPasswordStatus={checkPasswordStatus}
                passwordStatus={passwordStatus}
                currencies={currencies}
                networkFilter={networkFilter}
                getWalletPrivateKey={getWalletPrivateKey}
                getPassphrase={getPassphrase}
                getWalletMnemonicPhrase={getWalletMnemonicPhrase}
                setShowWalletBy={setShowWalletBy}
                isFromMerchantsWallets={isFromMerchantsWallets}
                resetTwoFaState={resetTwoFaState}
                updateList={updateList}
                downloadError={downloadError}
                setIsSegwit={setIsSegwit}
                walletVersion={effectiveWalletVersion}
              />
            ))}
          </div>
          {!fetching && page && pages && type !== 'admin' ? (
            <WalletsPagination
              page={page}
              pages={pages}
              walletsFilters={walletsFilters}
              loadMoreWallets={loadMoreWallets}
              submitFilters={submitFilters}
              formName={formName}
            />
          ) : null}
          {adminPages > 1 && type === 'admin' ? (
            <ReactPaginate
              pageCount={adminPages}
              pageRangeDisplayed={5}
              marginPagesDisplayed={2}
              onPageChange={loadMoreAdminWallets}
              containerClassName="pagination"
              activeClassName="active"
              previousLabel={'«'}
              nextLabel={'»'}
              breakLabel={'...'}
              forcePage={adminPage - 1}
            />
          ) : null}
        </>
      ) : canShowWallets ? (
        !fetching && !loading && <Empty description={t('nodata')} />
      ) : null}
      {(fetching || loading) && (
        <div className="wallets__loader">
          <Spin indicator={<LoadingOutlined className={`spin-${identity}`} style={{ fontSize: 24 }} spin />} />
        </div>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state, props) => ({
  wallets: state.merchantWallets.data,
  page: state.merchantWallets.page,
  pages: state.merchantWallets.pages,
  countItem: state.merchantWallets.countItem,
  fetching: state.merchantWallets.fetching,
  merchantData: state.merchantData.data,
  currencies: state.currencies.data,
  autosignStatus: state.withdraw.autosignStatus,
  passwordStatus: state.withdraw.passwordStatus,
  walletsFilters: formValueSelector(props.formName)(state, 'search', 'order', 'limit', 'currencyIds'),
  autosignStep: state.withdraw.autosignStep,
  downloadAutosignStep: state.withdraw.downloadAutosignStep,
  downloadError: state.withdraw.downloadError,
  userMerchants: state.adminUsers.userMerchants.data,
  isApprovedToken: state.currencies.isApproved.created,
});

const mapDispatchToProps = dispatch => ({
  getMerchantWallets: getMerchantWallets(dispatch),
  getMoreMerchantWallets: getMoreMerchantWallets(dispatch),
  getMerchantData: getMerchantData(dispatch),
  deleteMerchantWallet: deleteMerchantWallet(dispatch),
  setWalletAsMain: setWalletAsMain(dispatch),
  resetTwoFaState: resetTwoFaState(dispatch),
  getWalletPrivateKey: getWalletPrivateKey(dispatch),
  getPassphrase: getPassphrase(dispatch),
  resetPageCounter,
  getWalletMnemonicPhrase: getWalletMnemonicPhrase(dispatch),
  getMerchantBalances: getMerchantBalances(dispatch),
  getWithdrawWallets: getWithdrawWallets(dispatch),
  checkAutosignStatus: checkAutosignStatus(dispatch),
  setPasswordSignature: setPasswordSignature(dispatch),
  downloadAutosign: downloadAutosign(dispatch),
  checkPasswordStatus: checkPasswordStatus(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(WalletsList);
